<template>
    <div>
        <div v-for="(item,index) in treeData" :value="item.name" :key="index">
            <div v-if="disableId!=item.id||isShowAll">
                <div class="tree-item">
                    <i class="el-icon-arrow-right" :class="{'active':item.flag}" @click.stop="showChildren(item)" v-if="item.children.length>0"></i>
                    <el-option  :value="item.id" :label="item.name" style="flex: 1;"></el-option>
                </div>
                <option-tree style="margin-left: 20px;" v-show="item.flag&&item.children&&item.children.length>0" :treeData="item.children"></option-tree>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name:'optionTree',
        props:['treeData','isShowAll'],
        methods:{
            showChildren(item){
                item.flag=!item.flag;
            },
            /**递归添加属性 */
            handleData(arr){
                arr.forEach((item)=>{
                    if(item.flag===undefined){
                        this.$set(item,'flag',false);
                        if(arr.children&&arr.children.length>0){
                            this.handleData(item.children);
                        }
                    }
                })
            }
        },
        computed:{
            disableId(){
                return this.$store.state.business.currentQyId;
            }
        },
        watch:{
            treeData:{
                handler(newVal){
                    this.handleData(newVal);
                },
                immediate: true
            }
        },
    }
</script>

<style lang="less" scoped>
.tree-item{
    display: flex;
    align-items: center;
    position: relative;
    i{
        position: absolute;
        top: 33%;
        left: 5px;
        z-index: 9;
        transition: all 0.3s;
        cursor: pointer;
        font-size: 12px;
        color: rgb(102, 102, 102);
    }
}
.active{
    transform:rotate(90deg) !important;
}
</style>